/**
 * Tap diagnostics stay on the development project. A main or LIVE build
 * does not open /tap-check and does not log [tap].
 */

const DEV_PROJECT_REF = 'ftrhhpaduufkjfkjwzru';

function devTapToolsEnabled(env) {
  const source = env || (typeof process !== 'undefined' ? process.env : {});
  const url = String(source.REACT_APP_SUPABASE_URL || source.SUPABASE_URL || '');
  return url.indexOf(DEV_PROJECT_REF) !== -1;
}

module.exports = {
  DEV_PROJECT_REF,
  devTapToolsEnabled,
};
